export default "__VITE_ASSET__XvFKeWjD__"